import React from "react";
import "./investmentCard.css";

function InvestmentCards() {
  const cards = [
    {
      id: 1,
      title: "EMPRÉSTIMO REMUNERADO",
      subtitle: "",
      perfil: (
        <>
          <span className="fw-bold">Como Funciona:</span>{" "}
          <span>
            O Investidor recebe todo mês a fração correspondente a 8% anual e ao
            final de 12 meses recebe o valor do capital investido integralmente.
          </span>
        </>
      ),
      description: "INVESTIDOR EMPRESTA SEU CAPITAL À IMO INVESTIMENTOS.",
      details:
        "Buscamos imóvel já remodelado ou em primeira venda para compra abaixo do mercado e valorização para revenda de 6 a 18 meses.",
      profitability: "Rentabilidade Garantida: 8% ao ano em Euro",
      image: "emprestimo.png",
    },
    {
      id: 2,
      title: "GERAÇÃO DE CAPITAL",
      subtitle: "(IMO-FIX)",
      perfil: (
        <>
          <span className="fw-bold">Como Funciona:</span>{" "}
          <span>
            Buscamos os projetos com as melhores rentabilidades para compra,
            reforma, revenda ou construção total, com objetivos de retorno em curto prazo.
          </span>
        </>
      ),
      description: "SOCIEDADE ENTRE INVESTIDOR E A IMO INVESTIMENTOS.",
      details:
        "Buscamos imóvel que precisa de uma remodelação total, pois aumenta nossa capacidade de compra com grande potencial de retorno de 4 a 12 meses.",
      profitability: "Rentabilidade Estimada: 15% a 25% aa em Euro",
      image: "imofix.webp",
    },
    {
      id: 3,
      title: "CONSTRUÇÃO DE PATRIMÔNIO",
      subtitle: "(IMO-BUILD)",
      perfil: (
        <>
          <span className="fw-bold">Como Funciona:</span>{" "}
          <span>
            Auxiliamos o investidor na construção de um patrimônio imobiliário
            em euro para renda de aluguel e valorização do patrimônio.
          </span>
        </>
      ),
      description:
        "CONSTRUÇÃO E ADMINISTRAÇÃO DE PATRIMÔNIO IMOBILIÁRIO EM EURO.",
      details:
        "Buscamos um terreno ou uma casa com necessidade de reconstrução e por ser um projeto mais longo o tempo médio de retorno é de 12 a 24 meses.",
      profitability: "Rentabilidade Estimada: 8% a 16% aa em Euro",
      image: "residencia.jpeg",
    },
  ];

  return (
    <div
  style={{
    padding: "40px 20px",
    backgroundColor: "#ffffff", // fundo da seção branco
    borderRadius: "10px",
  }}
>
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      gap: "40px",
      flexWrap: "wrap",
    }}
  >
    {cards.map((card) => (
      <div
        key={card.id}
        className="p-3"
        style={{
          width: "430px",
          minHeight: "500px",
          backgroundColor: "#111111", // card preto premium
          borderRadius: "15px",
          border: "1px solid #ECA600",
          boxShadow: "0 6px 15px rgba(0, 0, 0, 0.2)",
          textAlign: "center",
          overflow: "hidden",
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.transform = "translateY(-5px)";
          e.currentTarget.style.boxShadow = "0 12px 25px rgba(0, 0, 0, 0.3)";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 6px 15px rgba(0, 0, 0, 0.2)";
        }}
      >
        {/* Título */}
        <h5
          className="special-font"
          style={{
            color: "#ffffff",
            padding: "10px",
            fontWeight: "bold",
            fontSize: "20px",
            letterSpacing: "1px",
          }}
        >
          {card.title}
        </h5>

        {/* Imagem */}
        <div
          className="mt-3"
          style={{
            height: "200px",
            backgroundColor: "#1a1a1a", // mantém dentro do tom preto
          }}
        >
          <img
            src={card.image}
            alt={card.title}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "12px",
            }}
          />
        </div>

        {/* Conteúdo */}
        <div style={{ padding: "20px" }}>
          <p
            className="special-font fw-bold mb-3"
            style={{ fontSize: "18px", color: "#ffffff" }}
          >
            {card.description}
          </p>

          <span
            className="special-font"
            style={{
              fontSize: "15px",
              display: "block",
              textAlign: "left",
              color: "#cccccc",
              lineHeight: "24px",
            }}
          >
            {card.perfil}
          </span>

          {/* Rentabilidade */}
          <p
            className="special-font mt-4"
            style={{
              fontSize: "14px",
              fontWeight: "bold",
              letterSpacing: "0.6px",
              color: "#ECA600",
            }}
          >
            {card.profitability}
          </p>
        </div>
      </div>
    ))}
  </div>
</div>

  );
}

export default InvestmentCards;

